import React from 'react';
import { Link } from 'react-router-dom';
import { CircleDot, Hourglass, Timer, Trash2 } from 'lucide-react';
import { carrierLabel } from '../../constants/shipments';
import { formatDate, formatDateTime, relativeTime } from '../../utils/shipmentsFormat';
import { CopyButton } from './Ui';

// Small tags next to the status. Each fact is shown once: a shipment without any status is already "Ke kontrole"
// in its badge, "Zpožděná" is a tag only (the date cell does not repeat it), "Čeká na tracking" replaces any "no number" text.
export const RowTags = ({ row }) => (
  <>
    {row.deletedAt && <span className="shp-tag shp-tag--bad"><Trash2 size={12} aria-hidden="true" /> Smazáno</span>}
    {row.needsReview && row.status != null && <span className="shp-tag shp-tag--warn"><span className="shp-dot" aria-hidden="true" /> Ke kontrole</span>}
    {row.flags?.awaitingTracking && <span className="shp-tag shp-tag--info"><Hourglass size={12} aria-hidden="true" /> Čeká na tracking</span>}
    {row.flags?.delayed && <span className="shp-tag shp-tag--warn"><Timer size={12} aria-hidden="true" /> Zpožděná</span>}
    {row.flags?.stuck && <span className="shp-tag shp-tag--warn"><CircleDot size={12} aria-hidden="true" /> Dlouho bez pohybu</span>}
    {row.status === 'problem' && !row.needsReview && <span className="shp-sr">Problémová zásilka</span>}
  </>
);

// Carrier + tracking number on one line (the number is the keyboard-reachable link to the detail) + copy button,
// optionally the description as one ellipsized line underneath (table only).
export const TrackingCell = ({ row, description }) => {
  const id = Number(row.id);
  return (
    <div style={{ minWidth: 0 }}>
      <div className="shp-trk">
        <span className="shp-carrier">{carrierLabel(row.carrierCode, row.carrierName)}</span>
        <Link to={`/zasilky/${id}`} dir="auto" className="shp-wrap">
          {row.trackingNumber || row.orderRef || `Zásilka č. ${id}`}
        </Link>
        {row.trackingNumber && <CopyButton value={row.trackingNumber} />}
      </div>
      {description && <div className="shp-cell-sub shp-ellipsis" dir="auto" title={description}>{description}</div>}
    </div>
  );
};

// Customer and / or supplier names as plain text
export const PartyCell = ({ row }) => {
  const parts = [
    row.customer?.name && { label: 'Zákazník', name: row.customer.name },
    row.supplier?.name && { label: 'Dodavatel', name: row.supplier.name },
  ].filter(Boolean);
  if (parts.length === 0) {
    const fallback = row.direction === 'odchozi' ? row.recipientName : row.senderName;
    return <span className="shp-muted shp-wrap" dir="auto">{fallback || '–'}</span>;
  }
  return (
    <>
      {parts.map((p) => (
        <div key={p.label} className="shp-wrap" dir="auto" style={{ minWidth: 0 }}>
          {p.name} <span className="shp-sr">({p.label})</span>
        </div>
      ))}
    </>
  );
};

export const ExpectedCell = ({ row }) => {
  if (row.deliveredAt) return <span className="shp-nowrap">Doručeno {formatDate(row.deliveredAt)}</span>;
  if (!row.expectedDelivery) return <span className="shp-muted">–</span>;
  return <span className="shp-nowrap">{formatDate(row.expectedDelivery)}</span>;
};

export const LastEvent = ({ at }) => {
  if (!at) return <span className="shp-muted">–</span>;
  return <time dateTime={at} title={formatDateTime(at)} className="shp-nowrap">{relativeTime(at)}</time>;
};
